import { inject, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'noteSafeHtml',
  standalone: true,
})
export class NotesSafeHtmlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  public transform(value: string): SafeHtml {
    return value ? this.sanitizer.sanitize(SecurityContext.HTML, value.replace(/\n/g, '<br>')) : '';
  }
}
